export default {
  props: {
    values: {
      type: Array,
      required: true,
    },
    value: {
      type: Number,
      default: 15,
    },
  },
  computed: {
    appliedValue() {
      if(this.hasProp('value')) {
        return this.value;
      }
      return this.$store.state.grid.perPage;
    }
  },
  methods: {
    fireChange(e) {
      this.$store.commit('grid/setPerPage', e.target.value);
    },
  },
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/assets/js/theme-mixins/DataGridPerPage.js